.cardImage {
  cursor: pointer;
  position: absolute;
  filter: drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.4));

  &:hover {
    transform: scale(1.05);
  }
}

.handWrapper {
  position: relative;
}

.cardsWrapper {
  position: relative;
  &.selectionMade .cardImage:not(.selected):not(:hover) {
    opacity: 0.3;
  }
}

.selectedCardActionsWrapper {
  overflow: scroll;

  &.loading {
    pointer-events: none;
    opacity: 0.6;
  }
}

.actionChoicesList {
  color: var(--ds-grey-dark);
  & .actionChoice {
    margin-top: 4px;
    &.clickable {
      cursor: pointer;
    }
  }
}

.actionChoicesList:hover .actionChoice:not(:hover) {
  color: var(--ds-pearl-grey-darker);
}
.actionChoice:hover {
  color: var(--ds-black);
}

.turnLabelAndButtons {
  width: 100%;
  padding: 8px 0;
  height: 64px;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  min-width: max-content;
  align-items: flex-start;

  & :first-child {
    flex-grow: 1;
    align-self: center;
  }
}

.turnButtons {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  min-width: max-content;
  align-items: flex-end;
  margin-left: 20px;
}

.hideWhenDisabled:disabled,
.hidden {
  display: none;
}

.turnButton {
  margin-left: 8px;
}
